import { render, staticRenderFns } from "./ReactivosEvaluacionSection.vue?vue&type=template&id=2b2e2e7a&scoped=true"
import script from "./ReactivosEvaluacionSection.vue?vue&type=script&lang=js"
export * from "./ReactivosEvaluacionSection.vue?vue&type=script&lang=js"
import style0 from "./ReactivosEvaluacionSection.vue?vue&type=style&index=0&id=2b2e2e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2e2e7a",
  null
  
)

export default component.exports